<template>
  <div>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="confirmLeave(true)"
      @cancel="confirmLeave(false)"
      :active.sync="isSidebarActiveconfirmLeave"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <b-row style="margin-top: 15px">
          <b-col cols="12" align-self="center">
            <h6>{{ $t("LeavePageInfo") }}</h6>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
    <ProductAcceptance />
  </div>
</template>

<script>
import ProductAcceptance from "./ProductAcceptance.vue";

export default {
  components: {
    ProductAcceptance,
  },
  data() {
    return {
      isSidebarActiveconfirmLeave: false, // Prompt aktiflik durumu
      nextRouteCallback: null, // Rotaya devam etme callback fonksiyonu
    };
  },
  methods: {
		handleBeforeUnload(event) { 
      if (this.acceptedBarcodes.length > 0) {
        event.preventDefault();
        event.returnValue = "";
      }
    },
    confirmLeave(isConfirmed) {
      if (isConfirmed) {
        this.nextRouteCallback && this.nextRouteCallback(); // Geçişe izin ver
      } else {
        this.nextRouteCallback && this.nextRouteCallback(false); // Geçişi engelle
      }
      this.isSidebarActiveconfirmLeave = false; // Promptu kapat
    },
  },
	mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    if (this.acceptedBarcodes.length > 0) {
      // Barcode varsa promptu göster
      this.isSidebarActiveconfirmLeave = true;
      this.nextRouteCallback = next; // Callback fonksiyonunu sakla
    } else {
      next(); // Değişiklik yoksa geçişe izin ver
    }
  },
  computed: {
    acceptedBarcodes: {
      get() {
        return this.$store.state.stock.AcceptedBarcodes;
      },
    },
  },
};
</script>
